/**
 * 图片 URL 处理（与小程序一致）
 * - /images/ 静态资源走 IMAGE_BASE（OSS）
 * - 旧站 /upload、/images、历史代理 URL → OSS
 */
import { resolveUploadUrl, resolveImageAssetUrl, IMAGE_PUBLIC_BASE } from '@/utils/uploadBase'

const IMAGE_BASE = `${IMAGE_PUBLIC_BASE}/`

export function getImageUrl(imageName) {
  if (!imageName) return ''
  const raw = String(imageName).trim()
  if (!raw) return ''
  if (/^https?:\/\//i.test(raw)) {
    if (/wvxvb\.cn\/upload/i.test(raw) || /\/app\/oss\/file\/upload/i.test(raw)) {
      return resolveUploadUrl(raw)
    }
    if (/wvxvb\.cn\/images/i.test(raw)) {
      return resolveImageAssetUrl(raw)
    }
    return raw
  }
  const cleanName = raw.replace(/^\/static\/images\//, '').replace(/^\/+/, '')
  if (/^upload\//i.test(cleanName) || /^\d{14,}\w*\.(png|jpe?g|gif|webp|bmp)$/i.test(cleanName)) {
    return resolveUploadUrl(cleanName)
  }
  return IMAGE_BASE + cleanName
}

/**
 * 预加载图片（与小程序 utils 行为一致，弱网超时后仍 resolve）
 * @param {string[]} urls
 * @param {{ timeoutMs?: number }} options
 * @returns {Promise<void>}
 */
export function preloadImages(urls, options = {}) {
  const timeoutMs = options.timeoutMs != null ? Number(options.timeoutMs) : 25000
  const list = [...new Set((urls || []).filter(Boolean))]
  if (!list.length) {
    return Promise.resolve()
  }
  const fetchOne = (src) =>
    new Promise((resolve) => {
      const img = new Image()
      img.onload = () => resolve()
      img.onerror = () => resolve()
      img.src = src
    })
  return Promise.race([
    Promise.all(list.map(fetchOne)),
    new Promise((resolve) => setTimeout(resolve, timeoutMs))
  ])
}
